<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';


import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    router.push({ name:'cloudCounterVideoOperationReservationLoan' });
};

const passwordValue = ref('');

</script>

<template>

    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="1"></Process>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                查看預約申請內容
            </h2>
        </div>

        <h3 class="font-bold text-xl pb-2">輸入密碼</h3>
        <p class="pb-2">密碼為您的身分證字號，第一個英文字母需大寫</p>
        <input type="password" v-model="passwordValue" />

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="passwordValue === ''" @click="goNextPage">確認</button>
        </template>

    </Layout>

</template>

<style scoped>
</style>
